import * as type from "../../types/API/bomAdditionalCharges";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getBOMAdditionalChargesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_ADDITIONAL_CHARGES:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_ADDITIONAL_CHARGES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_ADDITIONAL_CHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addBOMAdditionalChargesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_BOM_ADDITIONAL_CHARGES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_BOM_ADDITIONAL_CHARGES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_BOM_ADDITIONAL_CHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMAdditionalChargesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BOM_ADDITIONAL_CHARGES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_BOM_ADDITIONAL_CHARGES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_ADDITIONAL_CHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMAdditionalChargesReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_ADDITIONAL_CHARGES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_ADDITIONAL_CHARGES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_ADDITIONAL_CHARGES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 